import {PolarisChatAggregate, PolarisChatId, PolarisOrigin} from './model';

export const ISO_DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const POLARIS_ORIGINS: ReadonlySet<PolarisOrigin> = new Set([
  'polaris_homepage',
  'alert_view_page',
  'polaris_wizard',
  'widget',
  'signals_screen'
]);

export const getChatSortTimestamp = (chat: PolarisChatAggregate | undefined): number => {
  if (!chat) {
    return 0;
  }
  const fallback = Date.parse(chat.overview.createdAt) || 0;
  return Date.parse(chat.overview.lastModified ?? chat.overview.lastMessageTime ?? chat.overview.createdAt) || fallback;
};

export const sortChatOrderByRecent = (
  chatOrder: PolarisChatId[],
  chatsById: Record<PolarisChatId, PolarisChatAggregate>
): PolarisChatId[] => {
  return [...chatOrder].sort((left, right) => {
    const leftTs = getChatSortTimestamp(chatsById[left]);
    const rightTs = getChatSortTimestamp(chatsById[right]);
    return rightTs - leftTs;
  });
};

export const toPolarisOrigin = (origin: string | undefined): PolarisOrigin | undefined => {
  if (!origin) {
    return undefined;
  }
  return POLARIS_ORIGINS.has(origin as PolarisOrigin) ? (origin as PolarisOrigin) : undefined;
};
